import { Spin } from 'antd';
import React from 'react';

function Loader() {
  return (
    <div className="container">
      <Spin />
    </div>
  );
}

export default Loader;
